import { useQuery } from "@tanstack/react-query";
import { authClient } from "@/lib/auth";
import { listPublicVideos } from "../api";

/**
 * The public clip feed. Refetched periodically so new posts show up. Watching
 * the feed is behind the sign-in wall, so it only loads for authenticated
 * users.
 */
export function usePublicVideos() {
  const { data: session } = authClient.useSession();
  return useQuery({
    queryKey: ["public-videos"],
    queryFn: listPublicVideos,
    refetchInterval: 30_000,
    enabled: Boolean(session?.session),
  });
}
